import { FC } from 'react';
import { Box, Typography, Button, Stack, Chip } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Colors } from '../../styles/theme';
import PartnerLogos from './PartnerLogos';
import { useMediaQuery, useTheme } from '@mui/material';
import SmoothLink from '../SmoothLink';
const MainSection: FC = () => {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Box
        sx={{
          width: '100%',
          background: 'linear-gradient(180deg, #1675FF1A 0%, #1675FF00 100%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          pt: { xs: '40px', sm: '87px' },
          textAlign: 'center',
          px: 2,
        }}
      >
        <Box
          sx={{
            marginBottom: { xs: '40px', sm: '60px' },
          }}
        >
          <SmoothLink to="/#feature" style={{ textDecoration: 'none' }}>
            <Stack
              direction="row"
              spacing={{ xs: 1, sm: 2 }}
              alignItems="center"
              sx={{
                justifyContent: 'space-between',
                padding: '8px',
                opacity: 1,
                borderRadius: '8px',
                backgroundColor: '#FFFFFF80',
              }}
            >
              <Box
                sx={{
                  height: '25px',
                  px: { xs: '6px', sm: '9px' },
                  gap: '10px',
                  opacity: 1,
                  borderRadius: '4px',
                  backgroundColor: '#B9E2FF',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    color: '#38383B',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontSize: {
                      xs: '12px',
                      sm: '14px',
                    },
                    verticalAlign: 'middle',
                  }}
                >
                  New!
                </Typography>
              </Box>
              <Typography
                fontSize={{
                  xs: '12px',
                  sm: '14px',
                }}
                color="#38383B"
                sx={{
                  textAlign: 'left',
                }}
              >
                <span
                  style={{
                    fontWeight: 700,
                  }}
                >
                  Introducing the new Haist :{' '}
                </span>
                {isXs && <br />}
                <span
                  style={{
                    fontWeight: 400,
                  }}
                >
                  A new feature has been updated
                </span>
              </Typography>
              <ArrowForwardIcon
                sx={{
                  fontSize: '16px',
                  color: '#38383B',
                }}
              />
            </Stack>
          </SmoothLink>
        </Box>
        <Typography
          variant="h2"
          component="h1"
          sx={{
            fontWeight: 500,
            fontSize: {
              xs: '34px',
              sm: '56px',
              md: '100px',
            },
            color: Colors.blue,
            textAlign: 'center',
            marginBottom: '34px',
          }}
        >
          Snap, Diagnose, Impress
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: {
              xs: '14px',
              sm: '20px',
              md: '24px',
            },
            color: '#5F5F62',
            fontWeight: 400,
            maxWidth: '640px',
            mb: 4,
          }}
        >
          Snap a photo of any vehicle issue.{isXs && <br />} Haist AI identifies
          the problem, generates a repair report, and gets customer approval
          quickly. All in seconds.
        </Typography>
        <Stack direction="row" spacing={{ xs: 1, sm: 2 }} mb={6}>
          <SmoothLink to="/#download" style={{ textDecoration: 'none' }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: Colors.blue,
                borderRadius: '8px',
                padding: { xs: '8px 20px', sm: '16px 31px' },
                fontSize: { xs: '12px', sm: '16px' },
                fontWeight: 700,
                textTransform: 'none',
                color: '#FFFFFF',
                whiteSpace: 'nowrap',
              }}
            >
              Download Now
            </Button>
          </SmoothLink>
          <SmoothLink to="/#feature" style={{ textDecoration: 'none' }}>
            <Button
              variant="outlined"
              sx={{
                backgroundColor: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: { xs: '8px 20px', sm: '16px 31px' },
                fontSize: { xs: '12px', sm: '16px' },
                fontWeight: 700,
                textTransform: 'none',
                color: '#38383B',
                whiteSpace: 'nowrap',
              }}
            >
              Discover Haist
              <Box
                component="img"
                src="/images/discover_hos.svg"
                alt="Discover Haist"
                sx={{ ml: 1, width: 16, height: 16 }}
              />
            </Button>
          </SmoothLink>
        </Stack>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: { xs: '250px', sm: '500px', md: '650px' },
            maxWidth: '1440px',
            margin: '0 auto',
            '&::after': {
              content: '""',
              position: 'absolute',
              inset: 0,
              background: 'linear-gradient(180deg, transparent 70%, #fff 100%)',
              pointerEvents: 'none',
            },
          }}
        >
          <img
            src="/images/haist/main-bg.png"
            alt="background"
            style={{
              position: 'absolute',
              width: '100%',
              height: '100%',
              objectFit: 'contain',
              left: 0,
              top: 0,
            }}
          />
        </Box>
      </Box>
      <PartnerLogos />
    </Box>
  );
};

export default MainSection;
